import Asset from './asset';
import GenericModel from './generic-model';
import ProductSize from './product/product-size';

export class ProductSizeAsset extends GenericModel {
  archived?: boolean;
  productSize?: ProductSize;
  asset?: Asset;
  formSection?: string;

  // offline storage variables
  localFileUuid?: string;
}
